import React, { useState } from 'react'

import { Box, Typography, Button, FormControl, Select, MenuItem, CircularProgress } from '@mui/material';
import { useClient } from '../../../reactQuery/client';
import { useClientBuildings } from '../../../reactQuery/building';
import { generateAnnualComplianceSignUpPDF } from './AnnualComplianceSignUpReport/PDFGenerator';
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

function AnnualComplianceSignUpReport() {
    const [selectedClient, setSelectedClient] = useState('');
    const [loading, setLoading] = useState(false);
  
    // Fetch clients
     const { responseData: clients } = useClient(
       { pagination: false }
     );
  
     const { isLoading: isLoadingBuildings, error, responseData: buildings, isError, refetch, totalRecords } =
       useClientBuildings(
         {
           page: 1,
           pageSize: 1,
           clientId: selectedClient,
           pagination: false,
         },
         selectedClient
       );
  
    const handleClientChange = (event) => {
      setSelectedClient(event.target.value);
    };
  
    const handleGeneratePDF = async () => {
      if (!selectedClient || !buildings) return;
      
      setLoading(true);
      try {
        // Transform building data to match the format needed for PDF
        const pdfData = buildings.map((building) => ({
          id: building.id,
          name: building.name,
          address: building.address,
          units: building.units.length || 0,
          services: {
            annual: building?.mailer_program || false,
            ll55: building?.ll55_enabled || false,
            parapet: building?.parapet_enabled || false,
            backflow: building?.backflow_enabled || false,
            hpdAlert: building?.hpd_alert || false,

          },
        }));
  
        // Get client name for the PDF title
        const clientName = clients.find(c => c.client_id === selectedClient)?.company_name || 'Selected Client';
        
        // Generate and download the PDF
        const doc = await generateAnnualComplianceSignUpPDF(pdfData, clientName);
        doc.save(`${clientName}_Annual_Compliance_Sign_Up_Report.pdf`);
      } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('Failed to generate PDF. Please try again.');
      } finally {
        setLoading(false);
      }
    };
  return (
    <Box className="report-card-content">
      <Typography variant="body2" className="report-description">
      Generate a summary showing each property under the selected client and its annual compliance sign-up status.
      </Typography>
      <Box className="report-action">
        <FormControl className="client-select">
          <Select
            value={selectedClient}
            onChange={handleClientChange}
            displayEmpty
            className="select-box"
            // disabled={isLoadingClients}
            // renderValue={(selected) => {
            //   if (selected === "") {
            //     return <em>Select Client</em>;
            //   }
            //   return clients?.find(c => c.id === selected)?.name || selected;
            // }}
          >
            <MenuItem value="" disabled>
              <em>Select Client</em>
            </MenuItem>
            {clients?.map((client) => (
              <MenuItem key={client.client_id} value={client.client_id}>
                {client.company_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          className="property-service-btn"
          onClick={handleGeneratePDF}
          disabled={!selectedClient || isLoadingBuildings || loading}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadOutlinedIcon />}
        >
        Sign up Report
        </Button>
      </Box>
    </Box>
  )
}

export default AnnualComplianceSignUpReport